import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { Identifier, PayHistory, Widgets } from '@types';
import { instance } from '@utils/fetch';
import { config } from '../config';
import moment from 'moment/moment';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchPayHistoryAsync } from '@store/actions/payHistory.action';
import { selectLoanNumberSelected, selectSelectedLoanNumber } from '@store/selectors/widgets.selectors';
import { isEmpty } from 'lodash';
import { CodingConstants } from '@constants';

export const usePaymentHistoryQuery = (queryProps?: UseQueryOptions) => {
    const accountNumber = useSelector(selectLoanNumberSelected);
    const identifier: Identifier = useSelector(selectSelectedLoanNumber);

    const dispatch = useDispatch();
    const query = useQuery<PayHistory, any>({
        queryKey: ['payment-history', accountNumber],
        queryFn: async () =>
            await instance.request({
                url: `${config.env('awsUrl')}/api/v1/selfserv/loans/${accountNumber}/payments/history`,
                method: 'get',
                params: {
                    startDate: moment().subtract(3, 'months').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD')
                }
            }),
        select: ({ data }: any) => data,
        enabled: !isEmpty(identifier) && identifier.type === CodingConstants.servicingLoanType
    });
    useEffect(() => {
        if (query.isSuccess) {
            dispatch(fetchPayHistoryAsync.success(query.data));
        } else if (query.isError) {
            dispatch(fetchPayHistoryAsync.failure(query.error));
        }
    }, [query.isSuccess]);

    return query;
};
